import { Currency } from '@/core/currency/interfaces';

const KPW: Currency = {
    name: 'North Korean Won',
    demonym: 'North Korean',
    majorSingle: 'Won',
    majorPlural: 'Won',
    codeNumeric: '408',
    symbol: '₩',
    symbolNative: '₩',
    minorSingle: 'Chon',
    minorPlural: 'Chon',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'KPW',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default KPW;
